/*
  Miamon — reveal al hacer scroll.
  Sustituye al GSAP ScrollTrigger que usa la web en WordPress: aquí basta
  con añadir `.is-visible` una vez y que el CSS haga el resto.
  Se aplica a cualquier elemento con [data-mm-reveal].
*/
(function () {
  var SELECTOR = '[data-mm-reveal]';

  function revealAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  // Sin soporte o con movimiento reducido: mostrar todo de una.
  if (
    !('IntersectionObserver' in window) ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    document.addEventListener('DOMContentLoaded', function () {
      revealAll();
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
  );

  function observe(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.classList.contains('is-visible')) return;
      observer.observe(el);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    observe();
  });

  // Red de seguridad: una sección que ya esté en pantalla al cargar debe
  // verse aunque el observer no haya alcanzado a disparar.
  window.addEventListener('load', function () {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        el.classList.add('is-visible');
      }
    });
  });

  // El editor de temas reinyecta secciones sin recargar la página.
  document.addEventListener('shopify:section:load', function (event) {
    observe(event.target);
  });

  // En el editor no queremos que una sección recién seleccionada quede oculta.
  document.addEventListener('shopify:section:select', function (event) {
    revealAll(event.target);
  });
})();
